module.exports = __webpack_public_path__ + "7c266971a672dfe2c9c581614685b018.pdf";